import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useBusinesses, useCurrentUser } from '../../context/hooks';
import { GROUP_ACCOUNT_TYPES } from '../../constants';
import { ServiceType } from '../../types/user';
import { DEFAULT_MANAGEMENT_ROUTE, getFirstPermittedContentRoute } from '../../helpers/managementContentRoute';

/**
 * Subscription administrators (management users flagged in JWT) must not use account-level routes
 * (dashboard, subscription list, billing). Send them to their assigned subscription package page.
 */
export const SubscriptionAdminAccountRedirect = () => {
  const currentUser = useCurrentUser();
  const businesses = useBusinesses();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const isSubscriptionAdmin =
      currentUser?.serviceType === ServiceType.PINGPAD_MANAGEMENT &&
      Boolean(currentUser?.permissions?.some((p) => p.contentPermissions?.includes('SUBSCRIPTION_ADMIN')));

    if (!isSubscriptionAdmin || !businesses?.length) {
      return;
    }

    const id = businesses[0]._id;
    const path = location.pathname;

    const mustLeave =
      path === '/group' ||
      path === '/group/' ||
      path === '/group/dashboard' ||
      path === '/group/packages' ||
      path.startsWith('/group/billing') ||
      path.startsWith('/group/payments') ||
      path.startsWith('/group/new-subscription');

    if (mustLeave) {
      const perm = currentUser?.permissions?.find((p) => p.groupId === id);
      const contentRoute = getFirstPermittedContentRoute(perm?.contentPermissions) ?? DEFAULT_MANAGEMENT_ROUTE;
      history.replace(`/group/packages/${GROUP_ACCOUNT_TYPES.BUSINESS}/${id}/${contentRoute}`);
    }
  }, [currentUser, businesses, location.pathname, history]);

  return null;
};
